import { useSetImmerAtom } from 'jotai-immer';
import { useEffect, useState } from 'react';
import { cpOrderInvoicesSearchFormAtom } from './cp_order_invoices_search_atoms';
import { cpOrderInvoicesSearchStateVM } from './cp_order_invoices_search_view_models';
import { getDateRangeForMode } from '../../../../core/components/validation/ValidInputDate.utils';
import viewStateRepo from '../../../../core/repo/viewStateRepo';
import { useCpOrderInvoicesStore } from '../pagehooks/useCpOrderInvoicesStore';
import { CP_ORDER_INVOICES_LIST_FORM_KEY } from '../../cp_order_invoices_const';
import { useAtomValue } from 'jotai';
import { cpOrderInvoicesUserAffListAtom } from '../cp_order_invoices_list_atoms';
import { buildCpOrderInvoicesOptions } from '../pagehooks/useCpOrderInvoicesInit';

export const useCpOrderInvoicesSearchInit = (): boolean => {
    const [init, setInit] = useState(true);
    const { action } = useCpOrderInvoicesStore();
    const setSearchForm = useSetImmerAtom(cpOrderInvoicesSearchFormAtom);
    const userAffList = useAtomValue(cpOrderInvoicesUserAffListAtom);

    useEffect(() => {
        if (init && action === 'QUERY') {
            // Build options from centralized user context in page state atom
            const ctx = { User: { AffList: userAffList } };
            const options = buildCpOrderInvoicesOptions(ctx);

            const vs = viewStateRepo.getForm(CP_ORDER_INVOICES_LIST_FORM_KEY);

            // Date range initialization logic
            // Default to Month To Date and derive the start/end dates from that
            // mode so the date fields reflect the selected range on first load.
            const initialDateRangeMode = 'MTD';
            const { start: initialStartDate, end: initialEndDate } = getDateRangeForMode(initialDateRangeMode);

            const vsWithOptions = {
                ...vs,
                programAdminOptions: options.programAdminOptions,
                ceOptions: options.ceOptions,
                rxOptions: options.rxOptions,
                DateRangeMode: vs?.DateRangeMode ?? { val: initialDateRangeMode },
                StartDate: vs?.StartDate ?? { val: initialStartDate },
                EndDate: vs?.EndDate ?? { val: initialEndDate },
            };

            const formState = cpOrderInvoicesSearchStateVM(vsWithOptions, userAffList);

            setInit(false);
            setSearchForm(() => formState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [init, action, setSearchForm]);

    return init;
};
